import * as React from 'react';
import { Row, Col } from 'antd';
import '../../css/Login.scss';
import strings from '../../eyeguide-localization/login/infoPages';

const logo = require('../../images/logo.svg');

class ContactUs extends React.Component<{}, {}> {
    render() {
        return (
          <div className="Login"> 
                <div className="container">
                <Row>
                    <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
                    <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                    <div className="logoContainer"><img className="logo" src={logo} /></div>
                    </Col>
                    <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
                </Row>
                <Row className="signInTitle">
                    <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
                    <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                    <h2 className="logoContainer">{strings.lsContactUsTitle}</h2>
                    </Col>
                    <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
                </Row>
                <Row>
                    <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
                    <Col xs={20} sm={16} md={12} lg={8} xl={6} style={{textAlign: 'center'}}>
                    {strings.lsContactUsContentTxt}
                    </Col>
                    <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
                </Row>
                </div>
            </div>
            
            );
        }

}

export default ContactUs;


// WEBPACK FOOTER //
// ./src/components/login/contactus.tsx